module.exports = __webpack_public_path__ + "static/home-fdf216325f205af7187bb71f3333ee79.png";